export default __webpack_public_path__ + "static/media/pink-follow.3c51d11e.svg";